import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import HomeIcon from '@material-ui/icons/Home';
import Typography from '@material-ui/core/Typography';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

const Header = props => {
  const { location, title, classes,karaokeMode } = props;
  let typographyClasses = "tipologia flute-overflow";
  if(karaokeMode){
    typographyClasses = "tipologia";
  }
  return (
    <div className={'Header ' + classes['Header']}>
      <div className="HeaderContent">
        <Link className="backto" to={process.env.PUBLIC_URL + '/'}>
          <Button variant="contained" color="secondary">
            {location.pathname === process.env.PUBLIC_URL + '/' ? <HomeIcon /> : <KeyboardBackspaceIcon />}
            <label>HUB Music</label>
          </Button>
        </Link>
        <Typography variant="h2" className={typographyClasses}>{title}</Typography>
      </div>
    </div>
  );
};

Header.propTypes = {
  location: PropTypes.object.isRequired
};

export default withRouter(Header);
